import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useLanguage } from "../../context/LanguageContext";
import PhoneFormatModal from "../../components/PhoneFormatModal/PhoneFormatModal";

const Main = () => {
  const location = useLocation();
  const { language } = useLanguage();

  console.log(language);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <Navbar />
      <PhoneFormatModal />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Main;